import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./UniversityAdd.css";

const UniversityAdd = () => {
  const [universityName, setUniversityName] = useState("");
  const [universityAddress, setUniversityAddress] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory(""); // reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // const formData = new FormData();
    // formData.append("universityName", universityName);
    // formData.append("address", universityAddress);

    // category.forEach((cat) => {
    //   formData.append("category[]", cat);
    // });

    const payload = {
      universityName: universityName,
      address: universityAddress,
      category,
    };

    try {
      // Send POST request
      const response = await axios.post(
        `${API_BASE_URL}/universities`,
        payload
      );

      // Clear form and display success message
      setUniversityName("");
      setUniversityAddress("");
      setCategory([]);
      // setSuccessMessage("University added successfully!");
      alert("University added successfully!");
    } catch (error) {
      // setErrorMessage("Failed to add university. Please try again.");
      alert("Failed to add university. Please try again.");
      console.error(error);
    }
  };

  return (
    <>
      <div id="add-department-inner-wrapper">
        <div className="course-header-with-btns">
          <h5>University</h5>

          <div className="college-course-nav-btns">
            <Link to={"/university-add"}>
              <button className="college-add-course-add-btn">
                Add University
              </button>
            </Link>
            <Link to={"/university-all"}>
              <button className="college-all-course-btn">All University</button>
            </Link>
          </div>
        </div>

        <div className="">
          <div className="form-school-container">
            <h4 className="college-course-detail">University Details</h4>
            <form
              onSubmit={handleSubmit}
              className="college-course-detail-form"
            >
              <div className="input-group">
                <label className="label">University Name</label>
                <input
                  style={{
                    marginLeft: "1px",
                    borderBottomLeftRadius: "5px",
                    borderTopLeftRadius: "5px",
                  }}
                  type="text"
                  value={universityName}
                  onChange={(e) => setUniversityName(e.target.value)}
                  placeholder="Enter University Name..."
                  required
                />
              </div>
              <div className="input-group">
                <label className="label">Address</label>
                <input
                  style={{
                    marginLeft: "1px",
                    borderBottomLeftRadius: "5px",
                    borderTopLeftRadius: "5px",
                  }}
                  type="text"
                  value={universityAddress}
                  onChange={(e) => setUniversityAddress(e.target.value)}
                  placeholder="Enter University Address..."
                  required
                />
              </div>

              {/* -------------------- */}

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Select Category</label>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <select
                    className="school-class-add-input-tag"
                    value={selectCategory}
                    onChange={(e) => setSelectCategory(e.target.value)}
                  >
                    <option value="">-Select Category-</option>
                    <option
                      value="Assignment"
                      disabled={category.includes("Assignment")}
                    >
                      Assignment
                    </option>
                    <option
                      value="Subjective_Exam"
                      disabled={category.includes("Subjective_Exam")}
                    >
                      Subjective Exam
                    </option>
                    <option
                      value="Exam_Notes"
                      disabled={category.includes("Exam_Notes")}
                    >
                      Exam Notes
                    </option>
                    <option
                      value="video_section"
                      disabled={category.includes("video_section")}
                    >
                      Video Section
                    </option>
                  </select>
                  <button
                    type="button"
                    onClick={handleAddCategory}
                    className="btn-s"
                  >
                    Add
                  </button>
                </div>
              </div>

              {category.length > 0 && (
                <div className="selected-categories">
                  <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                  <ul>
                    {category.map((cat, index) => (
                      <li key={index} style={{ marginBottom: "5px" }}>
                        {cat.replaceAll("_", " ")}
                        <button
                          type="button"
                          onClick={() => handleRemoveCategory(cat)}
                          style={{
                            marginLeft: "10px",
                            background: "red",
                            color: "white",
                            border: "none",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="college-course-form-btns">
                <button type="submit" className="btn-search">
                  Save
                </button>
                <button type="button" className="btn-cancel">
                  Cancel
                </button>
              </div>

              {errorMessage && <p className="error-message">{errorMessage}</p>}
              {successMessage && (
                <p className="success-message">{successMessage}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UniversityAdd;
